import {
    Box,
    VStack,
} from '@chakra-ui/react';
import { OccupantContact } from '@acp/shared';
import { OccupantRow } from '../../occupant/components/occupant-row';

export function OccupantsTable({
    occupants,
}: {
    occupants: OccupantContact[];
} & React.ComponentProps<typeof Box>) {
    return (
        <VStack alignItems="flex-start" spacing={4}>
            {
                occupants.map((occupant, id) => (
                    <OccupantRow
                        // eslint-disable-next-line react/no-array-index-key
                        key={id}
                        name={occupant.name}
                        email={occupant.email}
                        contactNumbers={occupant.contactNumbers}
                        isBlacklisted={occupant.isAllContactNumbersBlacklisted}
                    />
                ))
            }
        </VStack>
    );
}
